import Utils from './utils';
import ImageMediaRenderer from 'libs/image-media-renderer';

export default function(params) {
  var self = this;

  self.defaults = {};
  self.disabled = ko.observable(false);
  self.enabled = ko.observable(true);

  self.config = _.extend({}, self.defaults, params);

  // Map all properties to 'self'
  ko.mapping.fromJS(params, {}, self);

  self.isNative = ko.observable(false);
  self.previewdImage = ko.observable(false);

  self.show = function(image, event) {
    if(self.disabled()) return;

    if(!self.previewdImage()) {
      var $container = $('#js-video-' + self.id());
      var renderer;
  
      if (image.media_s3_url()) {
        renderer = new ImageMediaRenderer({
          src: image.media_s3_url(),
          $container: $container.parent(),
          style: {'max-width': '100%'}
        });
      } else {
        renderer = new ImageMediaRenderer({
          src: image.media_src.url(),
          $container: $container.parent(),
          style: {'max-width': '100%' }
        });
      }

      renderer.present();
      $container.remove(); // remove the video container
      self.previewdImage(true);
    }

    Utils.toggleRowVisibility(event);
  };

  return self;
}
